import * as tslib_1 from "tslib";
import * as React from 'react';
import { stylesheetSinglentone } from "./singlentone";
export var styleSinglentone = function () {
    var sheet = stylesheetSinglentone();
    return (function (_super) {
        tslib_1.__extends(Sheet, _super);
        function Sheet() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Sheet.prototype.componentDidMount = function () {
            sheet.add(this.props.styles);
        };
        Sheet.prototype.componentWillUnmount = function () {
            sheet.remove();
        };
        Sheet.prototype.render = function () {
            return null;
        };
        return Sheet;
    }(React.PureComponent));
};
